// extracted by mini-css-extract-plugin
export var active = "_jr-2";
export var recordingDot = "_jr-1";
export var recordingIndicator = "_jr-0";